export const auditModes = {
  EDIT: "EDIT",
  CREATE: "CREATE",
};

export const PROFESSIONAL = "P";

export const REFERENCE_ID = 'reference id';
export const NOTIFICATION_DATE = "notification date";
export const AUDIT_PERIOD = "audit period";
export const CLAIM_TYPE = "claim type";
export const TARGET_TYPE = "target type"
export const TARGET_VALUE = "target value";

export const COMPLETED_SATUS = "COMPLETED";

export const ATTACHED_LEVEL_NAME = {
  ExternalAudit: "EA",
  ExternalAuditCase: "EAC",
};

export const UPDATE_REQUESTER_INFO_IN_ROUND_CASES_WARNING_POPUP_MODE = {
  ALL_CASES_WITHOUT_ACTUAL_SUBMISSION_DATE:"ALL_CASES_WITHOUT_ACTUAL_SUBMISSION_DATE",
  ALL_CASES_WITH_ACTUAL_SUBMISSION_DATE:"ALL_CASES_WITH_ACTUAL_SUBMISSION_DATE"
};

export const allCasesWithoutActualSubmissionDate = "All cases in the current round without an actual submission date will be updated based upon the new values.";
export const allCasesWithActualSubmissionDate = "All cases in the current round have an actual submission date. No cases will be updated and these changes will not be saved.";



export const qioReviewContractorCodes = [
  "qior2",
  "qior5",
  "qior3",
  "qior7",
  "qior9",
  "qio2",
  "qio5",
  "qio3",
  "qio7",
  "qio9",
];
export const loadEventType = [
  { eventTypeId: 1, eventTypeName: "Audit Updates" },
  { eventTypeId: 2, eventTypeName: "Case  Updates" },
  { eventTypeId: 3, eventTypeName: "Round Updates" },
  { eventTypeId: 4, eventTypeName: "Task Updates" },
  { eventTypeId: 5, eventTypeName: "Upload Documents" },
];